import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const FiveNineIcon: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon {...props}>
    <path
      d="M19.972 13.657c2.123 0 3.279 1.55 3.279 3.384v.509h-5.026c.05.991.741 1.66 1.796 1.66.805 0 1.421-.371 1.647-.904h1.52c-.326 1.326-1.508 2.194-3.216 2.194-1.948 0-3.33-1.438-3.33-3.384 0-2.058 1.395-3.459 3.33-3.459Zm0 1.29c-.955 0-1.621.644-1.722 1.462h3.443c-.075-.88-.767-1.463-1.721-1.463Zm8.331 4.651v.595h.101v-.215h.133l.108.215h.108l-.124-.237c.058-.022.104-.085.104-.17 0-.103-.077-.188-.207-.188h-.223Zm.102.292h.114c.068 0 .107-.047.107-.102 0-.058-.041-.102-.107-.102h-.114v.204Z"
      fill={preserveColor ? "#2A4CF9" : undefined}
    />
    <path
      d="M28.49 19.332a.546.546 0 0 0-.563.563c0 .313.218.561.57.561.35 0 .568-.252.568-.563a.553.553 0 0 0-.575-.561Zm0 .094c-.298 0-.464.205-.464.47s.177.47.47.47.47-.206.47-.473c0-.265-.177-.467-.476-.467ZM7.842 13.087h-3.72v2.318h3.394v1.413H4.122v3.52h-1.67v-8.677h5.39v1.426Zm5.714 5.33h.101l1.558-4.599h1.747l-2.426 6.52H12.69l-2.414-6.52h1.71l1.57 4.599Zm-3.673 1.921H8.249v-6.52h1.634v6.52ZM26.47 11.5c1.66 0 3.08 1.202 3.08 2.95 0 .62-.189 1.178-.452 1.661l-2.388 4.227h-1.923l1.923-3.123-.05-.05a1.33 1.33 0 0 1-.528.1c-1.295 0-2.752-.955-2.752-2.815 0-1.723 1.432-2.95 3.09-2.95Zm.002 1.55c-.83 0-1.409.62-1.409 1.4 0 .781.58 1.413 1.409 1.413.83 0 1.407-.62 1.407-1.413s-.578-1.4-1.407-1.4Z"
      fill={preserveColor ? "#2A4CF9" : undefined}
    />
  </BaseIcon>
);
